module.exports = __webpack_public_path__ + "static/media/image5.0b861c17.webp";